import createHistory from "history/createBrowserHistory";
import {routerMiddleware} from "react-router-redux";
import {ReduxStorageUtils} from "@cuatroochenta/co-redux-builders";
import {applyMiddleware, createStore} from "redux";
import thunk from "redux-thunk";
import {Provider} from "react-redux";
import {History} from "history";
import CombinedReducers from "./redux/CombinedReducers";
import Routing from "./routing/Routing";
import IdleTimer from 'react-idle-timer';
import "./App.scss";
import React, {createRef} from "react";
import Config from "./config/Config";
import {ROUTE_LOGIN} from "./routing/Routes";
import BaseGenericRequest from './commons/ws/BaseGenericRequest';
import AuthManager from './utils/AuthManager';
import { goToRoute } from './utils/Router';

BaseGenericRequest.AuthManager = AuthManager;

class App extends React.Component<{}> {

    private idleTimerRef = createRef<IdleTimer>();

    protected history: History;

    public componentWillMount() {
        this.history = createHistory();
        const middleware = routerMiddleware(this.history);
        ReduxStorageUtils.initialize(createStore(CombinedReducers, applyMiddleware(thunk, middleware)));
        AuthManager.initialized();
    }

    public onIdle = (event) => {
        AuthManager.logout();
        goToRoute(ROUTE_LOGIN);
        // recargamos por temas de seguridad
        window.location.reload();
    };

    public render() {
        return (
            <>
                <IdleTimer
                    ref={this.idleTimerRef}
                    element={document}
                    onIdle={this.onIdle}
                    debounce={250}
                    timeout={1000 * 60 * Config.INACTIVITY_TIMEOUT_MIN}/>
                <Provider store={ReduxStorageUtils.getStorage()}>
                    <Routing history={this.history}/>
                </Provider>
            </>
        );
    }

}

export default App;
